import { render, staticRenderFns } from "./combobox.vue?vue&type=template&id=48a013d5&scoped=true&"
import script from "./combobox.vue?vue&type=script&lang=ts&"
export * from "./combobox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a013d5",
  null
  
)

export default component.exports